import React from 'react'

// Node Modules
import { useTranslation } from 'react-i18next'

import Modal from 'components/Modal'

interface Props {
  onDismiss: () => void
}

const LocaleAvailableModal = ({onDismiss}:Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Modal show={true} onOk={onDismiss} onHide={onDismiss} hideCloseButton={true}>
        {t("helpcenter-gui-icu.init-language.msg")}
      </Modal>
    </>
  )
}

export default LocaleAvailableModal